export default __webpack_public_path__ + "assets/images/icon_上传成功.eb62aec5.png";